import Nango from '@nangohq/frontend';

export const getClient = (publicKey: string) => new Nango({ publicKey });
